import { compose, configureStore } from '@reduxjs/toolkit';
import persistState, { mergePersistedState } from 'redux-localstorage';
import adapter from 'redux-localstorage/lib/adapters/localStorage';
import filter from 'redux-localstorage-filter';
import rootReducer from './rootReducer';

// Sync Redux store with local storage
const reducer = compose(mergePersistedState())(rootReducer);

const storage = compose(filter('auth.login.data'))(adapter(window.localStorage));

const reduxSync = persistState(storage, 'user');

// Redux Toolkit Config
const enhancers = [reduxSync];
const store = configureStore({
  reducer,
  enhancers,
  // eslint-disable-next-line no-undef
  devTools: process.env.NODE_ENV !== 'production'
});

// Access store outside component hooks
export const state = store.getState();
export const dispatch = store.dispatch;

export default store;
